import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { CognitoUser } from 'amazon-cognito-identity-js';
import React from 'react';

import { useIsAssemblyBrandEnabled } from 'src/hooks/useIsAssemblyBrandEnabled';
import { AuthLinkActionButton } from 'src/legacy/components/Auth/AuthLinkActionButton';
import { OnboardingAuthLayoutProps } from 'src/legacy/components/Onboarding/Login/OnboardingAuthLayout';

import { AccountForm } from './AccountForm';
import { ConfirmForm } from './ConfirmForm';

export type MfaFormProps = {
  onMfaRequired: (user: CognitoUser, email: string) => void;
};

type OnboardingForgotPasswordFormProps = OnboardingAuthLayoutProps &
  MfaFormProps;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationActionsContainerDesktop: {
      display: 'flex',
      justifyContent: 'space-between',
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    navigationActionsContainerMobile: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(2.5),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    returnPortalBtnWrapper: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(3),
    },
  }),
);

export const OnboardingForgotPasswordForm = ({
  onAuthComplete,
  onMfaRequired,
}: OnboardingForgotPasswordFormProps) => {
  const classes = useStyles();
  const [email, setEmail] = React.useState('');
  const { isAssemblyBrandEnabled } = useIsAssemblyBrandEnabled();

  // Using this state to determine which form to show to the user
  const [delivery, setDelivery] = React.useState<string | null>(null);

  const onSuccessSendCode = (deliveryMedium: string, userEmail: string) => {
    setDelivery(deliveryMedium);
    setEmail(userEmail);
  };

  return (
    <div>
      <div>
        {delivery ? (
          <ConfirmForm
            email={email}
            onSuccess={onAuthComplete}
            onMfaRequired={onMfaRequired}
          />
        ) : (
          <AccountForm onSuccess={onSuccessSendCode} />
        )}
      </div>
      <div className={classes.returnPortalBtnWrapper}>
        <AuthLinkActionButton href="/login">
          {isAssemblyBrandEnabled ? (
            <strong>{'Return to sign in'}</strong>
          ) : (
            'Return to sign in'
          )}
        </AuthLinkActionButton>
      </div>
    </div>
  );
};
